export default __webpack_public_path__ + "static/media/CPASAGE_Client home page icons-02.458456c3.svg";